import {
  FieldErrors,
  FormState,
  UseFormClearErrors,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormResetField,
  UseFormSetError,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form'
import { BeneficiaryEntityType, BeneficiaryTransferDestination } from 'types/beneficiaries'
import { FiatSendFormData } from './form/fiatSendFormSchema'

export interface FiatSendFormProps {
  formValues: FiatSendFormData
  formState?: FormState<FiatSendFormData>
  errors: FieldErrors<FiatSendFormData>
  register: UseFormRegister<FiatSendFormData>
  setValue: UseFormSetValue<FiatSendFormData>
  setError: UseFormSetError<FiatSendFormData>
  clearErrors: UseFormClearErrors<FiatSendFormData>
  handleSubmit?: UseFormHandleSubmit<FiatSendFormData>
  resetField?: UseFormResetField<FiatSendFormData>
  trigger: UseFormTrigger<FiatSendFormData>
  watch: UseFormWatch<FiatSendFormData>
}

export interface LegacyFiatPayoutWalletDetails {
  currency: string
  id: number
  lsid: string
  name: string
  supportedTransferDestinations: BeneficiaryTransferDestination[]
}

export interface LegacyFiatPayoutBeneficiaryDetails {
  alias: string
  currency: string
  entityType?: BeneficiaryEntityType
  id?: number
  name: string
  reference?: string
  transferDestination: BeneficiaryTransferDestination
  isThirdParty: boolean
}

export const ConfirmationOfPayeeCalloutTypes = {
  PAYOUT: 'payout',
  BENEFICIARY: 'beneficiary',
  BANK_ACCOUNT: 'bankAccount',
} as const

export type ConfirmationOfPayeeCalloutType =
  (typeof ConfirmationOfPayeeCalloutTypes)[keyof typeof ConfirmationOfPayeeCalloutTypes]
